var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"1107e85798f63d9206e61275ad62975084b08133"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["weiterbildung@developer-akademie-gmbh"]={id:"1107e85798f63d9206e61275ad62975084b08133"};
      